import React, { Component } from "react";
import { connect } from "react-redux";
import isEqual from "lodash/isEqual";
// import debounce from "lodash/debounce";

// import classnames from "classnames";

import withStyles from "@material-ui/core/styles/withStyles";
import Divider from "@material-ui/core/Divider";
import MuiButton from "@material-ui/core/Button";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import ArrowUpward from "@material-ui/icons/ArrowUpward";

import { SweetAlert, FETCH_START, FETCH_END, SAVING_START, SAVING_END, showNotification, RestMethods } from "jazasoft";

import { dataProvider } from "../../../App";
import handleError from "../../../utils/handleError";
import { toFixed, getDistinctValues, toFixedSigned, isEmpty } from "../../../utils/helpers";
import { cbLayRowSort } from "../../../helpers/orderHelper";
import { REGEX_DECIMAL, REGEX_COMMA_SEPARATED_DECIMAL } from "../../../utils/regex";
import Table, { TextInput, SelectInput, Toolbar, DefaultRowRenderer } from "../../../components/Table";
import CardHeader from "../../../components/CardHeader";
import SettingKeys from "../../../utils/SettingKeys";
import fetchSetting from "../../../utils/fetchSetting";

import { SET_LAY } from "./layReducer";
import WidthVariationDialog from "./WidthVariationDialog";
import { SpreadingType } from "../../../utils/types";
import { LayState, MULTI_PART_MANUAL_PLAN } from "../../../constants";
import { format } from "date-fns";
import { Typography } from "@material-ui/core";
import { markerGroupName } from "../../grouping/groupingHelper";

const Deviation = {
  SHORTAGE_EXCESS: "shortage-excess-meterage",
  ROLL_SPLITTING: "roll-splitting",
  WIDTH_VARIATION: "width-variation",
  MANUAL_PLAN: "manual-plan",
  MISSING: "missing",
  REJECTED: "rejected"
};

const rowMapper =
  marker =>
  ({ rollInfo, ...row }) => ({
    ...row,
    rollInfo,
    rollNo: rollInfo.rollNo,
    length: `${toFixed(rollInfo.length, 1)}`,
    currAvailable: `${toFixed(row.currRollLength, 1)} ${rollInfo.rollNo.includes("(") ? "" : `(${toFixed(rollInfo.length, 1)})`}`,
    style: rollInfo.style,
    color: rollInfo.color,
    shade: rollInfo.shade,
    shrinkage:
      !isEmpty(rollInfo.warpShrPercent) && !isEmpty(rollInfo.weftShrPercent)
        ? `L${toFixedSigned(-rollInfo.warpShrPercent)}% W${toFixedSigned(-rollInfo.weftShrPercent)}%`
        : "-",
    width: rollInfo.width,
    plannedBalance: toFixed(row.plannedBalance, 2),
    aPly: row.actualPly,
    aBalance: row.actualBalance,
    cDeviation: row.causeDeviation,
    layLength: marker.layLength
  });

const styles = theme => ({
  container: {
    margin: "1.5em",
    padding: 0
  },
  card: {
    margin: "1.5em 0",
    padding: 0,

    boxShadow: theme.shadows[1],
    backgroundColor: "white"
  },
  displayCenter: {
    display: "flex",
    justifyContent: "center",
    padding: "1.5em"
  }
});

class LayEdit extends Component {
  state = {
    rows: {},
    actualIds: [], // LayRow Ids
    plannedIds: [], // LayRow Ids
    manualIds: [], //ids of manual Roll
    layCompleted: false,
    deviationTypes: null,
    searchText: "",
    restLaysCompleted: false, //Whether all other lays in this marker are completed or not
    alertActive: false,
    sweetAlert: {
      title: "",
      message: "",
      showCancel: false,
      alertType: "" // danger|warning
    },
    dialogActive: false,
    row: {},
    rollList: []
  };

  componentDidMount() {
    if (!this.props.lay) {
      this.back();
      return;
    }
    this.initRows(this.props);
    fetchSetting(SettingKeys.LAYSLIP_DEVIATION_CAUSES, this.props.dispatch, setting => this.setState({ deviationTypes: JSON.parse(setting.value) }));
    this.fetchRolls(this.props.orderFlow);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.lay, nextProps.lay)) {
      this.initRows(nextProps);
      this.fetchRolls(nextProps.orderFlow);
    }
  }

  initRows = (props = this.props) => {
    const { lay, layList } = props;
    if (!lay || !layList) return;
    const { marker } = lay;
    const laysCurrMarker = layList.filter(lay => marker.id === lay.marker.id);
    const restLays = laysCurrMarker.filter(l => l.id !== lay.id);

    const rowListCurrMarker = laysCurrMarker.flatMap(lay => lay.rowList);
    const rowList = rowListCurrMarker.filter(row => row.actualLayNo === lay.layNo);

    let restRows = restLays
      .flatMap(lay => lay.rowList)
      .filter(row => !row.completed)
      .map(rowMapper(marker));

    let rows = rowList.map(rowMapper(marker));

    const restLaysCompleted = restLays.filter(lay => lay.state !== LayState.COMPLETED).length === 0;
    if (restLaysCompleted) {
      rows = rows.concat(restRows);
    }
    const actualIds = rows
      .filter(row => row.actualLayNo === lay.layNo && row.completed === true)
      .sort((a, b) => (a.serialNo && b.serialNo ? a.serialNo - b.serialNo : 0))
      .map(r => r.id);
    const plannedIds = rows.filter(row => !row.completed && !row.causeDeviation).map(row => row.id);

    rows = rows.concat(restRows);
    rows = rows.reduce((acc, row) => ({ ...acc, [row.id]: row }), {});

    this.setState({ rows, actualIds, plannedIds, restLaysCompleted });
  };

  fetchRolls = orderFlow => {
    if (!orderFlow || this.state.rollList.length > 0) return;
    const options = {
      url: `rolls`,
      method: "get",
      params: { search: `cutOrderFlow.id==${orderFlow.id};(hasChild=='NULL',hasChild=='FALSE')`, size: 10000 }
    };
    this.props.dispatch({ type: FETCH_START });

    dataProvider(RestMethods.CUSTOM, undefined, options)
      .then(response => {
        const rollList = response.data.content?.map(roll => ({
          ...roll,
          currAvailable: `${toFixed(roll.available, 1)} (${toFixed(roll.length, 1)})`,
          actualPly: 0,
          aPly: 0,
          actualBalance: `${toFixed(roll.available)}`,
          aBalance: `${toFixed(roll.available)}`,
          cDeviation: Deviation.MANUAL_PLAN
        }));
        this.setState({ rollList: rollList || [] });
        this.props.dispatch({ type: FETCH_END });
      })
      .catch(err => {
        handleError(err, this.props.dispatch);
        this.props.dispatch({ type: FETCH_END });
      });
  };

  fetchLaySlip = () => {
    const { orderFlow, layTab, match } = this.props;
    if (orderFlow) {
      const orderId = match.params.orderId;
      const options = {
        url: `orders/${orderId}/lays`,
        method: "get",
        params: { flowId: orderFlow.id }
      };
      this.props.dispatch({ type: FETCH_START });
      dataProvider(RestMethods.CUSTOM, undefined, options)
        .then(response => {
          if (response.status === 200) {
            const layMap = response.data;
            const layList = layMap[layTab];
            const lay = layList.find(l => l.layNo === this.props.lay.layNo);
            this.props.dispatch({ type: SET_LAY, payload: { orderFlow, layTab, lay, layList } });
          }
          this.props.dispatch({ type: FETCH_END });
        })
        .catch(err => {
          console.log(err);
          this.props.dispatch({ type: FETCH_END });
        });
    }
  };

  getHeader = type => {
    const { orderFlow } = this.props;
    let colorCount = 1;
    let styleCount = 1;
    if (orderFlow) {
      colorCount = orderFlow.colorList?.length || 1;
      styleCount = orderFlow.styleList?.length || 1;
    }
    let columns = [];
    if (type === "layslip") {
      columns = [
        { dataKey: "action", title: "Action" },
        { dataKey: "rollNo", title: "Roll No." },
        { dataKey: "style", title: "Style" },
        { dataKey: "color", title: "Color" },
        { dataKey: "currAvailable", title: "Available" },
        { dataKey: "width", title: "Width" },
        { dataKey: "shade", title: "Shade" },
        { dataKey: "plannedPly", title: "Planned Plies" },
        { dataKey: "plannedBalance", title: "Planned Balance" },
        {
          dataKey: "aPly",
          title: "Actual Plies",
          element: <TextInput type="number" width={80} onChange={this.onChange} />
        },
        {
          dataKey: "aBalance",
          title: "Actual Balance",
          element: <TextInput width={80} onChange={this.onChange} disabled={({ record }) => record?.cDeviation === Deviation.WIDTH_VARIATION} />
        },
        {
          dataKey: "cDeviation",
          title: "Reason (Deviation)",
          element: (
            <SelectInput
              width={120}
              choices={this.state.deviationTypes ? this.state.deviationTypes.map(({ key, value }) => ({ id: key, name: value })) : []}
              allowEmpty={true}
              onChange={this.onChange}
            />
          )
        }
      ];
      if (orderFlow?.orderConfig?.multiPartBundling === MULTI_PART_MANUAL_PLAN) {
        columns = columns.filter(c => !["plannedPly", "plannedBalance", "cDeviation"].includes(c.dataKey));
      }
    } else if (type === "stage") {
      columns = [
        { dataKey: "action", title: "Action" },
        { dataKey: "rollNo", title: "Roll No." },
        { dataKey: "style", title: "Style" },
        { dataKey: "color", title: "Color" },
        { dataKey: "currAvailable", title: "Available" },
        { dataKey: "width", title: "Width" },
        { dataKey: "shrinkage", title: "Shrinkage" },
        { dataKey: "shade", title: "Shade" },
        { dataKey: "plannedPly", title: "Planned Plies" },
        { dataKey: "plannedBalance", title: "Planned Balance" }
      ];

      if (orderFlow?.orderConfig?.multiPartBundling === MULTI_PART_MANUAL_PLAN) {
        columns = columns.filter(c => !["plannedPly", "plannedBalance"].includes(c.dataKey));
      }
    }
    if (colorCount === 1) {
      columns = columns.filter(c => c.dataKey !== "color");
    }
    if (styleCount === 1) {
      columns = columns.filter(c => c.dataKey !== "style");
    }
    return columns;
  };

  validate = (layCompleted = false) => {
    const { orderFlow, lay } = this.props;
    if (!orderFlow || !orderFlow.orderConfig) return;
    /**
     * Validation
     */
    let layRowList = this.state.actualIds.map(id => this.state.rows[id]);
    let manualRows = this.state.rollList
      .filter(roll => this.state.manualIds.includes(roll.id))
      .map(roll => ({ ...roll, rollInfo: roll, remarks: null, id: null }));

    const rows = [...layRowList, ...manualRows];
    let splitRolls = [];
    let wvRolls = []; //width variation rolls
    let shadeWisePlyMap = {};

    const layLength = lay && lay.marker && lay.marker.layLength;

    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      let { plannedPly, aPly, actualPly, aBalance, actualBalance, cDeviation, causeDeviation, remarks, rollNo, shade, rollInfo } = row;
      if (!rollInfo) {
        plannedPly = 0;
      }
      shadeWisePlyMap[shade] = (shadeWisePlyMap[shade] || 0) + parseInt(aPly);
      let error;
      if (parseFloat(aPly) > parseFloat(plannedPly) && cDeviation !== Deviation.MANUAL_PLAN) {
        error = "Incorrect Reason. Row = " + (i + 1) + " Roll Number = " + rollNo + ". Reason should be Manual Plan.";
      } else if (cDeviation && cDeviation !== "") {
        if (cDeviation === Deviation.ROLL_SPLITTING && !REGEX_COMMA_SEPARATED_DECIMAL.test(aBalance)) {
          error =
            "Incorrect value of actual balance. Row = " +
            (i + 1) +
            ", Roll Number = " +
            rollNo +
            ".It should be comma separated numeric value in case of Roll Splitting";
        } else if (cDeviation === Deviation.SHORTAGE_EXCESS && !REGEX_DECIMAL.test(aBalance)) {
          error =
            "Incorrect value of actual balance. Row = " +
            (i + 1) +
            ", Roll Number = " +
            rollNo +
            ". In case of Shortage/Excess, value should be entered like- 2 or 2.4";
        } else if (cDeviation === Deviation.WIDTH_VARIATION) {
          const rmks = JSON.parse(remarks);
          if (!(REGEX_COMMA_SEPARATED_DECIMAL.test(aBalance) || REGEX_DECIMAL.test(aBalance))) {
            error = "Incorrect value for actualBalance. It should be postive numberic value or comma separated numeric value.";
          } else if (rmks.length === 0) {
            error = "Width variation length info missing.";
          } else if (rmks.filter(r => !r.length || !r.width || r.length === "" || r.width === "").length > 0) {
            error = "Width variation length info incomplete. Fill both Length and width.";
          } else if (
            rmks.filter(r => (r.length && r.length !== "" && parseFloat(r.length) <= 0) || (r.width && r.width !== "" && parseFloat(r.width) <= 0))
              .length > 0
          ) {
            error = "Width variation length info incorrect. Length and Width value must be positive number.";
          }
        }
      }
      if (!(aPly === actualPly && parseFloat(aBalance) === parseFloat(actualBalance)) && !cDeviation) {
        error = "Select Proper reason of Deviation. Row = " + (i + 1) + ", Roll Number = " + rollNo;
      }
      if (!error && !(REGEX_DECIMAL.test(aBalance) || REGEX_COMMA_SEPARATED_DECIMAL.test(aBalance))) {
        error = "Incorrect value for actualBalance. It should be postive numberic value or comma separated numeric value.";
      }
      if (parseInt(aPly) < 0) {
        error = "Ply must be positive number. Row = " + (i + 1) + ", Roll Number = " + rollNo;
      }
      if (SpreadingType.FACE_ONE_WAY !== orderFlow.orderConfig.spreadingType && orderFlow.orderConfig.plyPairPerRoll && parseInt(aPly) % 2 === 1) {
        error = "Ply must be in pair. Row = " + (i + 1) + ", Roll Number = " + rollNo;
      }

      //Show Warning if there shortage or excess of more than 10 meters
      let warning;
      let wvLength = 0; // Width Variation Length
      if (!cDeviation || !(cDeviation === Deviation.MISSING || cDeviation === Deviation.REJECTED)) {
        let list = JSON.parse(remarks || "[]");
        wvLength = list.reduce((acc, e) => acc + e.length, 0);
        let currLength = parseInt(aPly) * layLength + wvLength + `${aBalance}`.split(",").reduce((acc, chunk) => acc + parseFloat(chunk.trim()), 0);

        let orignalLength = parseInt(plannedPly) * layLength + actualBalance.split(",").reduce((acc, chunk) => acc + parseFloat(chunk.trim()), 0);
        if (orderFlow?.orderConfig?.multiPartBundling === MULTI_PART_MANUAL_PLAN) {
          orignalLength = parseInt(actualPly) * layLength + actualBalance.split(",").reduce((acc, chunk) => acc + parseFloat(chunk.trim()), 0);
        }
        if (currLength - orignalLength > 10) {
          warning =
            "Confirm that roll - " +
            rollNo +
            " has excess fabric of " +
            toFixed(currLength - orignalLength) +
            " meters from mill. This can be a manual error in entry.";
        } else if (currLength - orignalLength < -10) {
          warning =
            "Confirm that roll - " +
            rollNo +
            " has  fabric shortage of " +
            toFixed(currLength - orignalLength) +
            " meters from mill. This can be a manual error in entry.";
        }
      }

      if (error) {
        this.setState({
          alertActive: true,
          sweetAlert: { title: "Error", message: error, alertType: "danger" },
          layCompleted
        });
        return;
      }

      if (warning) {
        this.setState({
          alertActive: true,
          sweetAlert: {
            title: "Are you sure?",
            alertType: "warning",
            message: warning
          },
          layCompleted
        });
        return;
      }

      if (cDeviation && cDeviation === Deviation.ROLL_SPLITTING && (!causeDeviation || causeDeviation !== cDeviation)) {
        splitRolls.push(rollNo);
      }
      if (cDeviation && cDeviation === Deviation.MANUAL_PLAN && `${aBalance}`.includes(",") && (!causeDeviation || causeDeviation !== cDeviation)) {
        splitRolls.push(rollNo);
      }
      if (cDeviation && cDeviation === Deviation.WIDTH_VARIATION && (!causeDeviation || causeDeviation !== cDeviation)) {
        wvRolls.push(rollNo);
      }
    }

    if (layCompleted && this.state.restLaysCompleted && this.state.plannedIds.length > 0) {
      this.setState({
        alertActive: true,
        sweetAlert: {
          title: "Error",
          message: "Some rolls are still not layed. Lay each rolls before completing lay.",
          alertType: "danger"
        },
        layCompleted
      });
      return;
    }

    if (splitRolls.length > 0) {
      this.setState({
        alertActive: true,
        sweetAlert: {
          title: "Are you sure?",
          alertType: "warning",
          message: "Confirm that roll No [" + splitRolls.join(", ") + "] has/have been split. Feedback for split rolls cannot be modified later."
        },
        layCompleted
      });
      return;
    }
    if (wvRolls.length > 0) {
      this.setState({
        alertActive: true,
        sweetAlert: {
          title: "Are you sure?",
          alertType: "warning",
          message:
            "Confirm that roll No [" + wvRolls.join(", ") + "] have Width Variation. Feedback for Width Variation Rolls cannot be modified later."
        },
        layCompleted
      });
      return;
    }

    if (layCompleted) {
      if (SpreadingType.FACE_ONE_WAY !== orderFlow.orderConfig.spreadingType) {
        let error;
        Object.keys(shadeWisePlyMap).forEach(shade => {
          if (shadeWisePlyMap[shade] % 2 === 1) {
            error = "Plies must be in pair for shade = " + shade;
          }
        });
        if (error) {
          this.setState({
            alertActive: true,
            sweetAlert: {
              title: "Error",
              message: error,
              alertType: "danger"
            },
            layCompleted
          });
          return;
        }
      }
      this.setState({
        alertActive: true,
        sweetAlert: {
          alertType: "warning",
          title: "Are you sure?",
          message: "You are submitting this lay. Please, Review lay carefully as you will not be able to modify once lay is submitted."
        },
        layCompleted
      });
      return;
    }
    this.onSave(layCompleted);
  };

  onSave = layCompleted => {
    const { layTab, lay, orderFlow, match } = this.props;
    if (!orderFlow) return;
    this.setState({ alertActive: false, sweetAlert: {} });

    let layRowList = this.state.actualIds.map(id => this.state.rows[id]);
    let manualRows = this.state.rollList
      .filter(roll => this.state.manualIds.includes(roll.id))
      .map(roll => ({ ...roll, rollInfo: roll, remarks: null, id: null }));
    let rows = [...layRowList, ...manualRows];

    const isManualPlan = orderFlow.orderConfig?.multiPartBundling === MULTI_PART_MANUAL_PLAN;

    const orderId = match.params.orderId;
    rows = rows.map((row, idx) => ({
      ...row,
      actualPly: row.aPly,
      actualBalance: row.aBalance,
      causeDeviation: isManualPlan ? "manual-plan" : row.cDeviation,
      remarks: row.cDeviation === Deviation.WIDTH_VARIATION ? row.remarks : null,
      serialNo: idx + 1
    }));
    let options = {
      url: `orders/${orderId}/feedback`,
      method: "post",
      params: { flowId: orderFlow.id, action: "layslip" },
      data: { layRowList: rows, layNo: lay.layNo, layTab, layCompleted: layCompleted || this.state.layCompleted }
    };

    this.props.dispatch({ type: FETCH_START });
    this.props.dispatch({ type: SAVING_START });
    dataProvider(RestMethods.CUSTOM, undefined, options)
      .then(response => {
        if (response.status === 200) {
          this.props.dispatch(showNotification("Feedback saved successfully."));
          this.setState({ manualIds: [] });
          if (layCompleted || this.state.layCompleted) {
            this.back();
          } else {
            this.fetchLaySlip();
          }
        }
        this.props.dispatch({ type: FETCH_END });
        this.props.dispatch({ type: SAVING_END });
      })
      .catch(err => {
        this.setState({ layCompleted: false });
        handleError(err, this.props.dispatch);
        this.props.dispatch({ type: FETCH_END });
        this.props.dispatch({ type: SAVING_END });
      });
  };

  back = () => {
    const {
      history,
      location: { pathname, state }
    } = this.props;
    history.push(pathname.substring(0, pathname.length - 4), state);
  };

  onSearch = searchText => {
    this.setState({ searchText });
  };

  onChange =
    ({ column, record }) =>
    event => {
      // const value = e.target.value;
      // this.setState(({ rows }) => {
      //   let newRows = [...rows];
      //   const row = { ...newRows[rowIdx], [column.dataKey]: value };
      //   newRows.splice(rowIdx, 1, row);
      //   return { rows: newRows };
      // });

      if (!record.id) return;
      let rows = { ...this.state.rows };
      let rollList = this.state.rollList.slice();
      const layLength = this.props.lay.marker.layLength;

      const value = event.target ? event.target.value : event.value;
      let row = rows[record.id];
      if (!row) {
        row = rollList.find(roll => roll.id === record.id);
      }
      row[column.dataKey] = value;
      if (column.dataKey === "aPly") {
        if (REGEX_DECIMAL.test(record.aBalance) && REGEX_DECIMAL.test(record.actualBalance)) {
          let aBalance = parseFloat(record.actualBalance);
          aBalance += layLength * (parseInt(record.actualPly) - parseInt(value.trim() === "" ? "0" : value.trim()));
          if (row["cDeviation"] !== Deviation.WIDTH_VARIATION) {
            row["aBalance"] = toFixed(aBalance, 2);
          }
        }
      }
      let dialogActive = false;
      let layRow = {};
      if (column.dataKey === "cDeviation") {
        if (value === Deviation.WIDTH_VARIATION) {
          dialogActive = true;
          let rows = isEmpty(record.remarks) ? [] : JSON.parse(record.remarks);
          if (record.actualBalance !== record.aBalance && !isEmpty(record.aBalance)) {
            if (`${record.aBalance}`.includes(",")) {
              rows = [
                ...rows,
                ...record.aBalance
                  .split(",")
                  .map(e => Number(e))
                  .filter(e => e > 0)
                  .map(len => ({ width: record.width, length: len }))
              ];
            } else if (Number(record.aBalance) > 0) {
              rows.push({ width: record.width, length: Number(record.aBalance) });
            }
          }
          layRow = { ...record, remarks: JSON.stringify(rows) };
        } else {
          // row["remarks"] = null;
        }
      }
      this.setState({ rows, rollList, row: layRow, dialogActive });
    };

  onMoveUp = (event, rowData) => {
    if (rowData.rollInfo) {
      const actualIds = [...this.state.actualIds, rowData.id];
      const plannedIds = this.state.plannedIds.filter(id => id !== rowData.id);
      this.setState({ actualIds, plannedIds });
    } else {
      const manualIds = [...this.state.manualIds, rowData.id];
      this.setState({ manualIds });
    }
  };

  onMoveDown = (event, rowData) => {
    if (rowData.rollInfo) {
      const plannedIds = [...this.state.plannedIds, rowData.id];
      const actualIds = this.state.actualIds.filter(id => id !== rowData.id);
      this.setState({ actualIds, plannedIds });
    } else {
      const manualIds = this.state.manualIds.filter(id => id !== rowData.id);
      this.setState({ manualIds });
    }
  };

  onCancel = () => {
    this.setState({ alertActive: false, sweetAlert: {}, layCompleted: false });
  };

  onClose = rows => {
    let rowList = { ...this.state.rows };
    if (this.state.row && this.state.row.id && rowList[this.state.row.id]) {
      const layRow = rowList[this.state.row.id];
      const sameWidthRows = rows.filter(e => `${e.width}` === `${layRow.width}`);
      const actualBalance = sameWidthRows.map(e => e.length).join(",");
      const remarks = JSON.stringify(
        rows
          .filter(e => `${e.width}` !== `${layRow.width}`)
          .map(row => Object.keys(row).reduce((acc, key) => ({ ...acc, [key]: parseFloat(row[key]) }), {}))
      );
      rowList[this.state.row.id]["remarks"] = remarks;
      rowList[this.state.row.id]["aBalance"] = isEmpty(actualBalance) ? "0" : actualBalance;
    }
    this.setState({ dialogActive: false, rows: rowList, row: {} });
  };

  render() {
    const { classes, orderFlow, lay, saving } = this.props;
    const { rows = {}, actualIds, plannedIds, manualIds, searchText, alertActive, sweetAlert, rollList } = this.state;
    const layLength = lay && lay.marker && lay.marker.layLength;
    // const markerName = lay && lay.marker && lay.marker.name;
    // const shrikageValue = lay && lay.marker.
    const rowsAll = Object.keys(rows).map(key => rows[key]);

    const sizeGroup = !isEmpty(lay?.marker?.name) ? getDistinctValues(lay.marker.name?.split(", ").map(e => e.split("_")[0])) : null;
    const markerName = !isEmpty(lay?.marker?.name)
      ? lay.marker.name
          ?.split(", ")
          .map(e => e.split("_")[1])
          .join(", ")
      : "";

    const rowsActual = getDistinctValues(actualIds)
      .map(id => rows[id])
      .map(row => ({
        ...row,
        action: !row.completed ? <ArrowDownward style={{ cursor: "pointer" }} onClick={e => this.onMoveDown(e, row)} /> : null
      }));

    const rowsActualManual = getDistinctValues(manualIds)
      .map(id => rollList.find(roll => roll.id === id))
      .map(roll => ({
        ...roll,
        action: <ArrowDownward style={{ cursor: "pointer" }} onClick={e => this.onMoveDown(e, roll)} />
      }));
    const selectedRowIds = [...rowsActual, ...rowsActualManual].map(row => row.id);
    let rowsPlanned =
      searchText.trim() === ""
        ? plannedIds
            .map(id => rows[id])
            .sort(cbLayRowSort)
            .map(row => ({
              ...row,
              action: <ArrowUpward style={{ cursor: "pointer" }} onClick={e => this.onMoveUp(e, row)} />
            }))
        : rowsAll
            .filter(row => !selectedRowIds.includes(row.id) && row.rollNo.toLowerCase().includes(searchText.trim().toLocaleLowerCase()))
            .map(row => ({
              ...row,
              action: <ArrowUpward style={{ cursor: "pointer" }} onClick={e => this.onMoveUp(e, row)} />
            }));
    let selectedRollIds = [...rowsActual, ...rowsPlanned].map(row => row.rollInfo && row.rollInfo.id);
    selectedRollIds = [...selectedRollIds, ...rowsActualManual.map(e => e.id)];

    const rowsPlannedManual =
      searchText.trim() === ""
        ? []
        : rollList
            .filter(roll => roll.available >= layLength)
            .filter(
              roll =>
                !manualIds.includes(roll.id) &&
                !selectedRollIds.includes(roll.id) &&
                roll.rollNo.toLowerCase().includes(searchText.trim().toLocaleLowerCase())
            )
            .map(roll => ({ ...roll, action: <ArrowUpward onClick={e => this.onMoveUp(e, roll)} /> }));

    if (orderFlow?.orderConfig?.multiPartBundling === MULTI_PART_MANUAL_PLAN) {
      rowsPlanned = rollList
        .filter(roll => roll.available >= layLength)
        .filter(roll => !selectedRollIds.includes(roll.id))
        .map(roll => ({
          ...roll,
          shrinkage: `${
            !isEmpty(roll.warpShrPercent) && !isEmpty(roll.weftShrPercent)
              ? `L${toFixedSigned(-roll.warpShrPercent)}% W${toFixedSigned(-roll.weftShrPercent)}%`
              : "-"
          }`,
          action: <ArrowUpward onClick={e => this.onMoveUp(e, roll)} />
        }));

      rowsPlanned =
        searchText.trim() === ""
          ? rowsPlanned
          : rowsPlanned.filter(roll => roll.rollNo.toLowerCase().includes(searchText.trim().toLocaleLowerCase()));
    }

    let rowList = rowsActual.length > 0 || rowsActualManual.length > 0 ? [...rowsActual, ...rowsActualManual] : [{}];

    let totalRow = {
      rollNo: "Total",
      plannedPly: rowList.reduce((acc, row) => acc + row.plannedPly, 0),
      // plannedBalance: rowList.reduce((acc, row) => acc + parseFloat(row.plannedBalance), 0).toFixed(2),
      aPly: rowList.reduce((acc, row) => acc + parseInt(row.aPly), 0)
      // aBalance: rowList.reduce((acc, row) => acc + parseFloat(row.aBalance), 0).toFixed(2)
    };
    if (rowList.length > 1) {
      rowList.push(totalRow);
    }

    let title1 = `Lay ${lay && lay.layNo}, Marker - ${markerName}${
      !isEmpty(sizeGroup) && sizeGroup !== "G1" ? ` (${sizeGroup})` : ""
    }, Lay Length = ${layLength}m, Group = ${markerGroupName(lay.marker)}`;

    let title2 = "";
    if (!isEmpty(lay?.table)) {
      title2 = `Table = ${lay?.table?.name}, Spreader Name = ${lay?.spreader?.fullName}`;
      if (!isEmpty(lay.cutNo)) {
        title2 = title2 + `, Cut No = ${lay?.cutNo}`;
      }
      if (!isEmpty(lay.prodType)) {
        title2 = title2 + `, Production Type = ${lay?.prodType}`;
      }
      if (!isEmpty(lay.startAt)) {
        title2 = title2 + `, Start Time = ${format(lay?.startAt, "dd MMM yy hh:mm a")}`;
      }
    }

    return (
      <div className={classes.root}>
        <div style={{ margin: "1em 1.5em" }}>
          <Typography variant="h5">{title1}</Typography>
          {!isEmpty(title2) && (
            <div style={{ marginTop: "1em" }}>
              <Typography variant="subtitle1" style={{ fontSize: 14 }}>
                {title2}
              </Typography>
            </div>
          )}
        </div>

        {alertActive && (
          <SweetAlert
            warning={sweetAlert.alertType === "warning"}
            danger={sweetAlert.alertType === "danger"}
            title={sweetAlert.title}
            onConfirm={sweetAlert.alertType === "warning" ? this.onSave : this.onCancel}
            onCancel={this.onCancel}
            showCancel={sweetAlert.alertType === "warning"}>
            <span style={{ fontSize: 16 }}>{sweetAlert.message}</span>
          </SweetAlert>
        )}

        <WidthVariationDialog open={this.state.dialogActive} layRow={this.state.row} onClose={this.onClose} />

        <div className={classes.container}>
          <div className={classes.card}>
            <CardHeader title="Actual Layslip" style={{ marginLeft: 0 }} />
            <Divider />
            <div style={{ overflowX: "auto" }}>
              <Table
                columns={this.getHeader("layslip")}
                rows={rowList}
                rowRenderer={({ columns, record, rowIdx }) => {
                  return record.rollNo === "Total" ? (
                    <TableRow key={rowIdx}>
                      {columns.map((column, colIdx) => (
                        <TableCell key={colIdx}>{record[column.dataKey]}</TableCell>
                      ))}
                    </TableRow>
                  ) : (
                    <DefaultRowRenderer key={rowIdx} columns={columns} record={record} rowIdx={rowIdx} />
                  );
                }}
              />
              <div style={{ display: "flex", justifyContent: "space-between", padding: "1em" }}>
                <div>
                  <MuiButton color="primary" variant="outlined" onClick={this.back}>
                    Back
                  </MuiButton>
                </div>
                <div>
                  <MuiButton color="primary" variant="outlined" disabled={saving} onClick={() => this.validate(true)}>
                    Submit
                  </MuiButton>
                  <MuiButton color="primary" variant="contained" style={{ marginLeft: "1em" }} disabled={saving} onClick={() => this.validate(false)}>
                    Save
                  </MuiButton>
                </div>
              </div>
            </div>
          </div>
          <div className={classes.card}>
            <Table
              columns={this.getHeader("stage")}
              rows={[...rowsPlanned, ...rowsPlannedManual]}
              toolbar={
                <Toolbar
                  title="Planned Layslip"
                  actions={[
                    {
                      name: "search",
                      tooltip: "Search Rolls",
                      placeholder: "Search",
                      value: searchText,
                      onSearch: this.onSearch
                    }
                  ]}
                />
              }
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect((state, props) => ({
  ...state.lay,
  orderId: props.match && props.match.params.orderId,
  saving: state.jazasoft.saving
}))(withStyles(styles)(LayEdit));
